<template>
  <div class="broker-select" v-if="clientId">
    <div v-if="clientListOptions.length > 1">
      <p class="broker-select__title">Выберите клиента</p>
      <!--        :disabled="onLoading"-->
      <fhs-select
        :options="clientListOptions"
        :disabled="onLoading"
        @handleSelect="changeSelectedBroker"
        class="broker-select__select"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SelectPrimary from "@/components/ui-kit/SelectPrimary";

export default {
  components: {
    "fhs-select": SelectPrimary
  },
  computed: {
    ...mapGetters([
      "getUserProfile",
      "getPortfolioLoading",
      "getIncomeYtdLoading",
      "getMoneyDataLoading"
    ]),

    clientId() {
      return this.getUserProfile
        ? this.getUserProfile.user
          ? this.getUserProfile.user.clientId
          : null
        : null;
    },
    clientListOptions() {
      if (this.clientId) {
        return this.$store.getters.getClientList.map(item => {
          if (this.clientId == item.value) {
            item.selected = true;
          } else {
            item.selected = false;
          }
          return item;
        });
      }
      return [];
    }
  },
  methods: {
    changeSelectedBroker(value) {
      this.$toasted.show("Загрузка...");
      this.$store.dispatch("changeSelectedClient", value).then(res => {
        if (res.data.status) {
          window.location.reload();
        } else {
          this.$toasted.show("Произошла ошибка при смене клиента");
        }
      });
    }
  },
  mounted() {
    this.$store.dispatch("fetchClientOptionList");
    // console.log(this.getUserProfile);
  }
};
</script>

<style scoped>
.broker-select {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.broker-select__title {
  margin: 0 0 5px 4px;
  font-size: 13px;
  color: #acb5c5;
}

.broker-select__select {
  padding: 0;
  font-size: 12px;
  color: #ffffff;
  background-color: #384770;
  border: none;
  padding: 4px;
}
.broker-select__select:disabled {
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 0.5;
}
</style>
